<template>
  <div class="goods-item" @click="toDetails(data.oid)">
    <div class="pic">
      <img v-lazy='`${data.url}?imageView2/1/w/350/h/350`' :key="data.url" />
    </div>
    <span class="title " :class="type == 'home' ? 'overflow' : 'two-line'">{{ getNm(data) }}</span>
    <div class="price-box">
      <span class="price">{{ $fn.initPrice(data.price || data.skuList[0].minPrice, 0) }}<i>{{ $fn.initPrice(data.price
        || data.skuList[0].minPrice, 1) }}</i><i>元</i></span>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  components: {

  },
  computed: {
  },
  methods: {
    toDetails(oid) {
      this.$emit('to', {})
      if (this.$route.path == '/goods/details') {
        this.$router.replace(`/goods/details?oid=${oid}&tiem=${new Date().getTime()}`);
      } else {
        this.$router.push(`/goods/details?oid=${oid}`);
      }
    },
    getNm(item) {
      if (!item.skuList || item.skuList.length == 0) {
        return this.$fn.sliceJz(item.nm);
      }
      let arr = [];
      if (item.nm) {
        arr.push(item.nm);
      }
      if (item.skuList[0].czStr) {
        arr.push(item.skuList[0].czStr);
      }
      if (item.skuList[0].skcStr) {
        arr.push(item.skuList[0].skcStr);
      }
      if (item.skuList[0].sizeStr) {
        arr.push(item.skuList[0].sizeStr);
      }
      return this.$fn.sliceJz(arr.join(','))
    },

  }
}
</script>

<style scoped lang="less">
.goods-item {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;

  .pic {
    position: relative;
    width: 100%;
    padding-bottom: 100%;
    border: 1px solid #dcdcdc;
    overflow: hidden;
    border-radius: 12px;

    >img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

  }

  .title {
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 34px;
    margin: 12px 12px 0 18px;
  }

  .price-box {
    display: flex;
    margin: 6px 18px 18px;

    .price {
      color: #F53F3F;
      font-family: Arial;
      font-size: 34px;
      font-style: normal;
      font-weight: 700;
      line-height: 48px;

      >i {
        font-size: 24px;
        line-height: 48px;
      }

      >i+i {
        color: #F53F3F;
        font-size: 24px;
        font-weight: bold;
      }
    }


  }

}
</style>
